import { Component, OnInit, OnDestroy, Input, ElementRef, OnChanges, HostListener } from '@angular/core';
import { EMPTY, Subscription } from 'rxjs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Center } from 'src/app/models/center-model/center.model';
import { CentersCentersService } from 'src/app/services/centers-services/centers-centers-service/centers-centers.service';
import { TIMEZONES } from 'src/assets/timezones/timezones';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';
import { COUNTRIES } from 'src/assets/countries/countries';

@Component({
  selector: 'app-centers-center-info-card',
  templateUrl: './centers-center-info-card.component.html',
  styleUrls: ['./centers-center-info-card.component.scss']
})
export class CentersCenterInfoCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() center: Center;
  @Input() centerTypeList;
  @Input() currencies;
  timezones;
  countries;
  editingLocked: boolean;
  updateCenterInfoSubscription: Subscription;
  basicDataForm = new FormGroup({
    visible: new FormControl({ value: null, disabled: true }, Validators.required),
    centerName: new FormControl({ value: null, disabled: true }, Validators.required),
    centerType: new FormControl({ value: null, disabled: true }, Validators.required),
    code: new FormControl({ value: null, disabled: true }),
    cif: new FormControl({ value: null, disabled: true }),
    fiscalName: new FormControl({ value: null, disabled: true }),
    fiscalAddress: new FormControl({ value: null, disabled: true }),
    street: new FormControl({ value: null, disabled: true }, Validators.required),
    zipCode: new FormControl({ value: null, disabled: true }, Validators.required),
    city: new FormControl({ value: null, disabled: true }, Validators.required),
    province: new FormControl({ value: null, disabled: true }, Validators.required),
    region: new FormControl({ value: null, disabled: true }, Validators.required),
    country: new FormControl({ value: null, disabled: true }, Validators.required),
    gpsLatitude: new FormControl({ value: null, disabled: true }, Validators.required),
    gpsLongitude: new FormControl({ value: null, disabled: true }, Validators.required),
    faxNumber: new FormControl({ value: null, disabled: true }),
    phoneNumber: new FormControl({ value: null, disabled: true }, Validators.required),
    centerMail: new FormControl({ value: null, disabled: true }, [Validators.required, Validators.email]),
    centerContactName: new FormControl({ value: null, disabled: true }, Validators.required),
    timeZone: new FormControl({ value: 'Europe/Madrid', disabled: true }, Validators.required),
    currency: new FormControl({ value: null, disabled: true }, Validators.required)
  });

  constructor(private centerCentersService: CentersCentersService,
              private snackbarService: SnackBarService,
              private eRef: ElementRef) {
                this.editingLocked = true;
                this.timezones = TIMEZONES;
                this.countries = COUNTRIES;
              }

  ngOnInit() { }

  ngOnChanges() {
    if (this.center) {
      this.resetForm();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
    } else {
      if (event.path && event.path[0].className !== 'mat-option-text') {
        if (this.center && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
        }
      }
    }
  }

  private submitForm() {
    this.updateCenterInfoSubscription = this.centerCentersService.updateCenterInfo(this.center.InternalId, this.basicDataForm.get('visible').value, this.basicDataForm.get('centerName').value, this.basicDataForm.get('cif').value, this.basicDataForm.get('fiscalName').value, this.basicDataForm.get('fiscalAddress').value, this.basicDataForm.get('street').value, this.basicDataForm.get('zipCode').value, this.basicDataForm.get('city').value, this.basicDataForm.get('province').value, this.basicDataForm.get('region').value, this.basicDataForm.get('country').value, this.basicDataForm.get('gpsLatitude').value, this.basicDataForm.get('gpsLongitude').value, this.basicDataForm.get('faxNumber').value, this.basicDataForm.get('phoneNumber').value, this.basicDataForm.get('centerMail').value, this.basicDataForm.get('centerContactName').value, this.getSelectedCenterType(), this.basicDataForm.get('timeZone').value, this.basicDataForm.get('currency').value.InternalId).pipe(
      tap(o => this.snackbarService.open('company-page.snackbar messages.update success', 'success')),
      tap(o => this.lockEdition()),
      tap(o => this.centerCentersService.refreshCenter()),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
      } else {
        this.snackbarService.open(validation, 'error');
      }
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('centerName').valid) {
      return 'stores-page.snackbar messages.centerName stores error';
    }  else if (!this.basicDataForm.get('street').valid) {
      return 'stores-page.snackbar messages.street stores error';
    } else if (!this.basicDataForm.get('centerType').valid) {
      return 'stores-page.snackbar messages.centerType stores error';
    } else if (!this.basicDataForm.get('province').valid) {
      return 'stores-page.snackbar messages.province stores error';
    } else if (!this.basicDataForm.get('zipCode').valid) {
      return 'stores-page.snackbar messages.zipCode stores error';
    } else if (!this.basicDataForm.get('city').valid) {
      return 'stores-page.snackbar messages.city stores error';
    } else if (!this.basicDataForm.get('region').valid) {
      return 'stores-page.snackbar messages.region stores error';
    } else if (!this.basicDataForm.get('country').valid) {
      return 'stores-page.snackbar messages.country stores error';
    } else if (!this.basicDataForm.get('gpsLatitude').valid) {
      return 'stores-page.snackbar messages.gpsLatitude stores error';
    } else if (!this.basicDataForm.get('gpsLongitude').valid) {
      return 'stores-page.snackbar messages.gpsLongitude stores error';
    } else if (!this.basicDataForm.get('fiscalName').valid) {
      return 'stores-page.snackbar messages.fiscalName stores error';
    } else if (!this.basicDataForm.get('fiscalAddress').valid) {
      return 'stores-page.snackbar messages.fiscalAddress stores error';
    } else if (!this.basicDataForm.get('cif').valid) {
      return 'stores-page.snackbar messages.cif stores error';
    } else if (!this.basicDataForm.get('phoneNumber').valid) {
      return 'stores-page.snackbar messages.phoneNumber stores error';
    } else if (!this.basicDataForm.get('centerMail').valid) {
      return 'stores-page.snackbar messages.centerMail stores error';
    } else if (!this.basicDataForm.get('centerContactName').valid) {
      return 'stores-page.snackbar messages.centerContactName stores error';
    } else if (!this.basicDataForm.get('currency').valid) {
      return 'stores-page.snackbar messages.currency stores error';
    } else {
      return true;
    }
  }

  private resetForm() {
    this.basicDataForm.patchValue({
      visible: this.center.Visible,
      centerName: this.center.CenterName,
      cif: this.center.Cif,
      fiscalName: this.center.FiscalName,
      fiscalAddress: this.center.FiscalAddress,
      centerType: this.setSelectedCenterType(),
      code: this.center.CenterCode,
      street: this.center.Street,
      zipCode: this.center.ZipCode,
      city: this.center.City,
      province: this.center.Province,
      region: this.center.Region,
      country: this.center.Country,
      gpsLatitude: this.center.GpsLatitude,
      gpsLongitude: this.center.GpsLongitude,
      faxNumber: this.center.FaxNumber,
      phoneNumber: this.center.PhoneNumber,
      centerMail: this.center.CenterMail,
      centerContactName: this.center.CenterContactName,
      timeZone: this.center.TimeZone,
      currency: this.setSelectedCurrency(),
    });
  }

  private unlockEdition() {
    this.basicDataForm.get('visible').enable();
    this.basicDataForm.get('centerName').enable();
    this.basicDataForm.get('cif').enable();
    this.basicDataForm.get('fiscalName').enable();
    this.basicDataForm.get('fiscalAddress').enable();
    this.basicDataForm.get('street').enable();
    this.basicDataForm.get('zipCode').enable();
    this.basicDataForm.get('city').enable();
    this.basicDataForm.get('province').enable();
    this.basicDataForm.get('region').enable();
    this.basicDataForm.get('country').enable();
    this.basicDataForm.get('gpsLatitude').enable();
    this.basicDataForm.get('gpsLongitude').enable();
    this.basicDataForm.get('faxNumber').enable();
    this.basicDataForm.get('phoneNumber').enable();
    this.basicDataForm.get('centerMail').enable();
    this.basicDataForm.get('centerContactName').enable();
    this.basicDataForm.get('code').enable();
    this.basicDataForm.get('centerType').enable();
    this.basicDataForm.get('timeZone').enable();
    this.basicDataForm.get('currency').enable();
    this.editingLocked = false;
  }

  private lockEdition() {
    this.basicDataForm.get('visible').disable();
    this.basicDataForm.get('centerName').disable();
    this.basicDataForm.get('cif').disable();
    this.basicDataForm.get('fiscalName').disable();
    this.basicDataForm.get('fiscalAddress').disable();
    this.basicDataForm.get('street').disable();
    this.basicDataForm.get('zipCode').disable();
    this.basicDataForm.get('city').disable();
    this.basicDataForm.get('province').disable();
    this.basicDataForm.get('region').disable();
    this.basicDataForm.get('country').disable();
    this.basicDataForm.get('gpsLatitude').disable();
    this.basicDataForm.get('gpsLongitude').disable();
    this.basicDataForm.get('faxNumber').disable();
    this.basicDataForm.get('phoneNumber').disable();
    this.basicDataForm.get('centerMail').disable();
    this.basicDataForm.get('centerContactName').disable();
    this.basicDataForm.get('code').disable();
    this.basicDataForm.get('centerType').disable();
    this.basicDataForm.get('timeZone').disable();
    this.basicDataForm.get('currency').disable();
    this.editingLocked = true;
  }

  public setSelectedCenterType() {
    if (this.center && this.centerTypeList && this.centerTypeList.length > 0) {
      for (const centerType of this.centerTypeList) {
        if (centerType.InternalId === this.center.CenterTypeInternalId) {
          return centerType;
        }
      }
    } else {
      return null;
    }
  }

  public setSelectedCurrency() {
    if (this.center && this.currencies && this.currencies.length > 0) {
      for (const currency of this.currencies) {
        if (currency.InternalId === this.center.Currency.InternalId) {
          return currency;
        }
      }
    } else {
      return null;
    }
  }

  public getSelectedCenterType() {
    if (this.centerTypeList && this.centerTypeList.length > 0) {
      if (this.basicDataForm.get('centerType').value) {
        return this.basicDataForm.get('centerType').value.InternalId;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }
  public setPreselected2(op1, op2) {
    if (op1 && op2) {
      return op1 === op2;
    }
  }

  ngOnDestroy() {
    if (this.updateCenterInfoSubscription) { this.updateCenterInfoSubscription.unsubscribe(); }
  }

}
